import React, {useEffect, useMemo, useState} from "react";
import axios from "axios";
import './YayinAkisiPage.scss';

const YayinAkisiPage = () => {
    const [data,setData] = useState([]);
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);

    const getData = async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await axios.get("https://obbtv.com/pro/api/index.php?api=bu_hafta_etkinlikler");
            const events = (res.data && res.data.events) ? res.data.events : [];
            const canli = events.filter(x => x.tur === "canli_yayin" || x.tur === "program_yayini");
            setData(canli);
        }catch(err){
            console.error(err);
            setError(err?.message || "Veri alınırken hata oluştu");
        }finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        getData();
    },[]);

    const groupedByDate = useMemo(() => {
        const groups = {};
        data.forEach(ev => {
            const start = ev.baslangic_tarihi ? new Date(ev.baslangic_tarihi) : null;
            const key = start ? start.toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' }) : 'Tarih bilinmiyor';
            if(!groups[key]) groups[key] = [];
            groups[key].push(ev);
        });
        // her grubu saat sırasına göre sırala
        Object.keys(groups).forEach(k => {
            groups[k].sort((a,b) => new Date(a.baslangic_tarihi) - new Date(b.baslangic_tarihi));
        });
        return groups;
    }, [data]);

    // yardımcı: saat formatı
    const formatTime = (iso) => {
        if(!iso) return "--:--";
        try{
            const d = new Date(iso);
            return d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
        }catch(e){
            return "--:--";
        }
    }

    // yardımcı: şu an veya sonraki programı bul
    const getCurrentPlaying = (events) => {
        if(!events || events.length === 0) return <div className="ya-now-empty">Yayın yok</div>;
        const now = Date.now();
        // normalize dates and search
        const withTimes = events.map(ev => ({
            ev,
            start: ev.baslangic_tarihi ? new Date(ev.baslangic_tarihi).getTime() : null,
            end: ev.bitis_tarihi ? new Date(ev.bitis_tarihi).getTime() : null
        })).filter(x => x.start);

        const live = withTimes.find(x => x.start <= now && (x.end ? x.end > now : true));
        if(live) return (
            <div className="ya-now-item">
                <div className="ya-now-time">{formatTime(live.ev.baslangic_tarihi)} - {live.ev.bitis_tarihi ? formatTime(live.ev.bitis_tarihi) : ''}</div>
                <div className="ya-now-title">{live.ev.baslik || live.ev.title}</div>
            </div>
        );
        const next = withTimes.filter(x => x.start > now).sort((a,b) => a.start - b.start)[0];
        if(next) return (
            <div className="ya-now-item ya-next">
                <div className="ya-now-time">{formatTime(next.ev.baslangic_tarihi)}</div>
                <div className="ya-now-title">{next.ev.baslik || next.ev.title}</div>
            </div>
        );
        return <div className="ya-now-empty">Yaklaşan yayın bulunmuyor</div>;
    }

    return(
        <div className="yayin-akisi-page">
            <div className="ya-container">
                <header className="ya-header">
                    <h1>Haftalık Yayın Akışı</h1>
                </header>

                {loading && <div className="ya-loading">Yükleniyor...</div>}
                {error && <div className="ya-error">{error}</div>}

                {!loading && !error && Object.keys(groupedByDate).length === 0 && (
                    <div className="ya-empty">Yayın bulunamadı.</div>
                )}

                <div className="ya-grid">
                    <main className="ya-main">
                        {Object.keys(groupedByDate).map(dateKey => (
                            <section className="ya-date-group" key={dateKey}>
                                <h2 className="ya-date">{dateKey}</h2>
                                <ul className="ya-list">
                                    {groupedByDate[dateKey].map(ev => (
                                        <li className="ya-item" key={ev.id || (ev.baslangic_tarihi + (ev.baslik||ev.title))}>
                                            <div className="ya-time">{formatTime(ev.baslangic_tarihi)}</div>
                                            <div className="ya-body">
                                                <div className="ya-title">{ev.baslik || ev.title}</div>
                                            </div>

                                        </li>
                                    ))}
                                </ul>
                            </section>
                        ))}
                    </main>

                    <aside className="ya-sidebar">
                        <div className="ya-card ya-now">
                            <h3>Şu an</h3>
                            {getCurrentPlaying(data)}
                        </div>

                        <div className="ya-card ya-info">
                            <h4>Bilgi</h4>
                            <p>Burada kanalın haftalık programı yer alır. İstediğiniz yayına tıklayarak detay ve canlı izleme sayfasına gidebilirsiniz.</p>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    )
}
export default YayinAkisiPage;